import { extendTheme } from '@chakra-ui/react';

import styles from './styles';

import breakpoint from './foundations/breakpoints';
import colors from './foundations/colors';
import fontSize from './foundations/typography';
import radii from './foundations/radii';
import shadow from './foundations/shadow';
import space from './foundations/space';

import Avatar from './components/Avatar';
import Button from './components/Button';
import Modal from './components/Modal';
import Tabs from './components/Tabs';
import Tooltip from './components/Tooltip';

const overrides = {
   styles,
   breakpoints: breakpoint,
   colors,
   fontSizes: fontSize,
   radii,
   shadows: shadow,
   space,
   components: {
      Avatar,
      Button,
      Modal,
      Tabs,
      Tooltip,
   },
};

export default extendTheme(overrides);
